import React, { Component } from "react";
import queryString from "query-string";
import { Result, Button } from "antd";

class IdCardPaymentResponsePage extends Component {
  state = {
    status: "",
    message: "",
    id_card_request_id: "",
    email: ""
  };

  componentDidMount() {
    const search = this.props.history.location.search;
    const searchData = queryString.parse(search);
    this.setState({
      status: searchData.status || "",
      message: searchData.message || "",
      id_card_request_id: searchData.id_card_request_id || "",
      email: searchData.email || ""
    });
  }

  goToPayment = () => {
    const { id_card_request_id, email } = this.state;
    if (id_card_request_id && email) {
      window.location.href = `/idcard-fees-payment?id_card_request_id=${id_card_request_id}&email=${encodeURIComponent(email)}`;
    } else {
      window.location.href = "/idcard-request";
    }
  };

  render() {
    const { status, message } = this.state;
    const isSuccess = status === "Success";

    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  ID Card Payment Response
                </div>
              </h3>
              <hr />

              <Result
                status={isSuccess ? "success" : "error"}
                title={
                  isSuccess ? "Payment successful" : `Payment ${status || "failed"}`
                }
                subTitle={
                  isSuccess
                    ? "Your payment has been received. The college office will print your ID card — please collect it from the office."
                    : message || "Your payment was not completed."
                }
                extra={
                  <Button type="primary" onClick={this.goToPayment}>
                    {isSuccess ? "View my application" : "Try again"}
                  </Button>
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IdCardPaymentResponsePage;
